import axios from "axios";
import { BASE_URL, SKOR_MODAL_PROXY_API } from "../../config";
// import toast, { ToastIcon } from "react-hot-toast";
import { toast } from "react-toastify";
import axiosInstance from "../../services/authWrapper";
import { constants } from "../../utils/constants";

export const getAllTenants = async (
  currentPage = 1,
  searchText = "",
  type = "all",
  sortBy = "Latest",
  digital_verification = "",
  bank_verified = "",
  have_guarantor = "",
  guarantor_scored = "",
  linked_property = "",
  sort_type = "",
  joined_from = "",
  employment_type = "",
  signal = null
) => {
  try {
    var sort_by = sortBy;
    var sort_type = sort_type;
    if (sortBy == "Latest" || sortBy == null) {
      sort_by = "created_at";
      sort_type = "desc";
    } else if (sortBy == "Oldest") {
      sort_by = "created_at";
      sort_type = "asc";
    } else if (sortBy == "Name [A-Z]") {
      sort_by = "fname";
      sort_type = "asc";
    } else if (sortBy == "Name [Z-A]") {
      sort_by = "fname";
      sort_type = "desc";
    }

    var url = `${BASE_URL}/admin/tenants`;
    if (type != "all")
      url += `?page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&type=${type}&searchText=${searchText}&sortBy=${sort_by}&sortType=${sort_type}&digital_verification=${digital_verification}&bank_verified=${bank_verified}&have_guarantor=${have_guarantor}&guarantor_scored=${guarantor_scored}&linked_property=${linked_property}&joined_from=${joined_from}&employment_type=${encodeURIComponent(employment_type)}`;
    else url += `?type=${type}`;
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: url,
      signal,
    });
    console.log("getAllTenants [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getAllTenants [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getAllTenants [ERROR] =>", err);
  }
};

export const searchAdminTenants = async (query, signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/search/tenant?query=${encodeURIComponent(query)}`,
      signal,
    });
    console.log("searchAdminTenants [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("searchAdminTenants [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("searchAdminTenants [ERROR] =>", err);
    return { success: false, data: [] };
  }
};

export const getAllLandlords = async (
  currentPage = 1,
  search = "",
  sortBy = "Latest",
  role = "",
  isLandlordInComp = "",
  sortType = "asc",
  agency = "all",
  signal = null
) => {
  try {
    var sort_by = sortBy;
    var sort_type = sortType;
    if (sortBy == "Latest" || sortBy == null) {
      sort_by = "createdAt";
      sort_type = "desc";
    } else if (sortBy == "Oldest") {
      sort_by = "createdAt";
      sort_type = "asc";
    } else if (sortBy == "Name [A-Z]") {
      sort_by = "fname_companyName";
      sort_type = "asc";
    } else if (sortBy == "Name [Z-A]") {
      sort_by = "fname_companyName";
      sort_type = "desc";
    }

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/landlords?page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&searchText=${search}&sortBy=${sort_by}&sortType=${sort_type}&role=${role}&isLandlordInComp=${isLandlordInComp}&agency=${agency}`,
      signal,
    });
    console.log("getAllLandlords [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getAllLandlords [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getAllLandlords [ERROR] =>", err);
  }
};

export const getCreditTransactions = async (
  currentPage = 1,
  search = "",
  agency,
  status,
  type,
  landlord_id,
  signal = null
) => {
  try {
    // Build query params dynamically
    const params = new URLSearchParams();
    params.append("page", currentPage);
    params.append("limit", constants.LISTING_ROWLIMIT);

    if (search) params.append("searchText", search?.trim());
    if (agency) params.append("agency", agency);
    if (status) params.append("status", status);
    if (type) params.append("type", type);
    if (landlord_id) params.append("landlord_id", landlord_id);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/getCreditsTransactions?${params.toString()}`,
      signal,
    });

    console.log("getCreditTransactions [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getCreditTransactions [REQUEST CANCELED]");
      return { status: "canceled", success: false };
    }
    console.log("getCreditTransactions [ERROR] =>", err);
  }
};

export const getAnalysisTransactions = async (
  currentPage = 1,
  search = "",
  status,
  analysis_type,
  signal = null
) => {
  try {
    // Build query params dynamically
    const params = new URLSearchParams();
    params.append("page", currentPage);
    params.append("limit", constants.LISTING_ROWLIMIT);

    if (search) params.append("searchText", search?.trim());
    if (status) params.append("status", status);
    if (analysis_type) params.append("analysis_type", analysis_type);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/getAnalysisLedger?${params.toString()}`,
      signal,
    });

    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getAnalysisTransactions [REQUEST CANCELED]");
      return { status: "canceled", success: false };
    }
    console.log("getAnalysisTransactions [ERROR] =>", err);
  }
};

export const getWorkspaceMetrics = async ({
  startDate = "",
  endDate = "",
  landlordId = "",
  workspaceId = "",
  tenantId = "",
  self_serving = undefined,
  landlord_type = "",
  signal = null
}
) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);
    if (landlordId) params.append("landlord_id", landlordId);
    if (workspaceId) params.append("workspaceId", workspaceId);
    if (tenantId) params.append("tenant_id", tenantId);
    if (self_serving) params.append("self_serving", self_serving);
    if (landlord_type) params.append("landlord_type", landlord_type);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/landLords/workspace-metrics?${params.toString()}`,
      signal,
    });
    console.log("getWorkspaceMetrics [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getWorkspaceMetrics [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getWorkspaceMetrics [ERROR] =>", err);
  }
};

export const getWorkspaceMetricsFullInfo = async (
{  startDate = "",
  endDate = "",
  landlordId = "",
  workspaceId = "",
  tenantId = "",
  self_serving = undefined,
  landlord_type = "",
  signal = null}
) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);
    if (landlordId) params.append("landlord_id", landlordId);
    if (workspaceId) params.append("workspaceId", workspaceId);
    if (tenantId) params.append("tenant_id", tenantId);
    if (self_serving) params.append("self_serving", self_serving);
    if (landlord_type) params.append("landlord_type", landlord_type);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/landLords/workspace-metrics/full-info?${params.toString()}`,
      signal,
    });
    console.log("getWorkspaceMetricsFullInfo [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getWorkspaceMetricsFullInfo [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getWorkspaceMetricsFullInfo [ERROR] =>", err);
  }
};

export const getLandlordActivityMetrics = async ({
  startDate = "",
  endDate = "",
  landlord_type = "",
  signal = null,
}) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (landlord_type) params.append("landlord_type", landlord_type);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/landlord-metrics/activity-metrics?${params.toString()}`,
      signal,
    });
    console.log("getLandlordActivityMetrics [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getLandlordActivityMetrics [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getLandlordActivityMetrics [ERROR] =>", err);
    return { success: false, message: err.message };
  }
};

export const getLandlordFunnelMetrics = async ({
  startDate = "",
  endDate = "",
  landlord_type = "",
  signal = null,
}) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (landlord_type) params.append("landlord_type", landlord_type);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/landlord-metrics/funnel?${params.toString()}`,
      signal,
    });
    console.log("getLandlordFunnelMetrics [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getLandlordFunnelMetrics [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getLandlordFunnelMetrics [ERROR] =>", err);
    return { success: false, message: err.message };
  }
};

export const getAllProperties = async (
  currentPage = 1,
  searchText = "",
  type = "all",
  sortBy = "Latest"
) => {
  try {
    var sort_by, sort_type;
    if (sortBy == "Latest") {
      sort_by = "created_at";
      sort_type = "desc";
    } else if (sortBy == "Oldest") {
      sort_by = "created_at";
      sort_type = "asc";
    }
    var url = `${BASE_URL}/admin/properties`;
    if (type != "all")
      url += `?page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&type=${type}&searchText=${searchText}&sortBy=${sort_by}&sortType=${sort_type}`;
    else url += `?type=${type}`;
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: url,
    });
    console.log("getAllProperties [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("getAllProperties [ERROR] =>", err);
  }
};

export const getAllPropertyDetails = async (
  currentPage = 1,
  searchText = "",
  type = "all",
  sortBy = "Latest",
  signal = null
) => {
  try {
    var sort_by, sort_type;
    if (sortBy == "Latest") {
      sort_by = "created_at";
      sort_type = "desc";
    } else if (sortBy == "Oldest") {
      sort_by = "created_at";
      sort_type = "asc";
    }
    var url = `${BASE_URL}/admin/properties-details`;
    if (type != "all")
      url += `?page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&type=${type}&searchText=${searchText}&sortBy=${sort_by}&sortType=${sort_type}`;
    else url += `?type=${type}`;
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: url,
      signal,
    });
    console.log("getAllPropertiesDetails [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getAllPropertyDetails [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getAllProperties [ERROR] =>", err);
  }
};

export const getAllOffers = async () => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/offers`,
    });
    console.log("getAllOffers [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("getAllOffers [ERROR] =>", err);
  }
};

//single functions
export const getLandlordProperties = async (landlordid) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/properties/${landlordid}`,
    });
    console.log("getLandlordProperties [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("getLandlordProperties [ERROR] =>", err);
  }
};

export const getLandlordPropertyDetails = async (landlordid) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/properties/property-details/${landlordid}`,
    });
    console.log("getLandlordProperties [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("getLandlordProperties [ERROR] =>", err);
  }
};

export const getSingleUser = async (userid, type) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/users/${userid}?type=${type}`,
    });
    console.log("getSingleUser [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("getSingleUser [ERROR] =>", err);
  }
};

export const createOffer = async (formvalue) => {
  try {
    const axiosRes = await axiosInstance({
      method: "POST",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/offers/`,
      data: formvalue,
    });
    console.log("createOffer [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("createOffer [ERROR] =>", err);
  }
};

export const editOffer = async (formvalue, offerid) => {
  try {
    const axiosRes = await axiosInstance({
      method: "POST",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/offers/single/${offerid}`,
      data: formvalue,
    });
    console.log("editOffer [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("editOffer [ERROR] =>", err);
  }
};

export const deleteOffer = async (offerid) => {
  try {
    const axiosRes = await axiosInstance({
      method: "DELETE",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/offers/single/${offerid}`,
    });
    console.log("deleteOffer [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("deleteOffer [ERROR] =>", err);
  }
};

export const getFeedbackDetails = async (tenantId, propId) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/landlords/get-feedback/${propId}/${tenantId}`,
    });
    return axiosRes.data;
  } catch (err) {
    console.log("getFeedbackDetails [ERROR] =>", err);
  }
};

export const getTenantKycDocs = async (tenantid) => {
  try {
    const docs = await axiosInstance.get(
      `${BASE_URL}/tenants/get-document/${tenantid}`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          responseType: "blob",
        },
      }
    );
    return docs;
  } catch (err) {
    console.log(err);
    toast.error("Error while fetching Tenant KYC Docs!");
  }
};

export const fetchTenantDocs = async (tenantId) => {
  try {
    // query params set "includeAll" to true
    const q = new URLSearchParams({
      includeAll: true,
    });
    const res = await axiosInstance.get(
      `${BASE_URL}/tenants/getUploadedDocuments?tenantId=${tenantId}&${q.toString()}`,
      {},
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const uploadFileData = async (filedata, tenantid) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/tenants/admin/uploadDocument/${tenantid}`,
      filedata,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return res;
  } catch (err) {
    toast.error("Error In Uploading File!");
  }
};

export const deleteTenantDoc = async (docId) => {
  try {
    const res = await axiosInstance.delete(
      `${BASE_URL}/tenants/deleteDoc?docId=${docId}`,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
    return res;
  } catch (err) {
    toast.error("Unable To Delete Document");
    console.log(err);
    return false;
  }
};

export const downloadTenantDoc = async (docId, fileName) => {
  try {
    const { data } = await axiosInstance.get(
      `${BASE_URL}/tenants/downloadDoc`,
      { params: { docId } }
    );

    if (!data?.url) {
      throw new Error("Document URL was not returned");
    }

    const { data: fileBlob } = await axios.get(data.url, {
      responseType: "blob",
    });
    const objectUrl = URL.createObjectURL(fileBlob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = fileName || data.filename || "download";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(objectUrl), 0);

    return true;
  } catch (err) {
    toast.error("Unable To Download Document");
    console.error("Download error:", err);
    return false;
  }
};

export const deleteLandlordDoc = async (docId) => {
  try {
    const res = await axiosInstance.delete(
      `${BASE_URL}/landlords/deleteDoc?docId=${docId}`,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
    return res;
  } catch (err) {
    toast.error("Unable To Delete Document");
    console.log(err);
    return false;
  }
};

export const loadSharedProfiles = async (tenantid) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/shared-profile/myshared-profiles/${tenantid}?profiletype=full`,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    toast.error("Error while fetching shared profiles");
  }
};

export const landlordLoadSharedProfiles = async (landlordId) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/shared-profile/landlord-received/${landlordId}?profiletype=full`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    toast.error("Error while fetching shared profiles");
  }
};

export const getWaitlist = async (
  searchVal,
  currentPage,
  sort_type = "desc",
  signal = null
) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/waitlist/data?page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&searchText=${searchVal}&sortType=${sort_type}`,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
        signal,
      }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getWaitlist [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    toast.error("Error while fetching shared profiles");
  }
};

export const downloadDocuSignDoc = async (data) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/download/docuSign`,
      data,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    toast.error("Error while downloading document!");
  }
};

export const updateUserInfo = async (formData = {}, id, type) => {
  try {
    const data = {
      formData,
      id: id,
      type,
    };
    const result = await axiosInstance.patch(
      `${BASE_URL}/users/update/info`,
      data,
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Accept-Language": localStorage.getItem("i18nextLng"),
        },
      }
    );
    return result.data;
  } catch (error) {
    toast.error("Error while updating info!");
  }
};

export const hardDeleteTenant = async (tenant_id) => {
  try {
    const result = await axiosInstance.delete(
      `${BASE_URL}/admin/delete/tenant?tenantId=${tenant_id}`,
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Accept-Language": localStorage.getItem("i18nextLng"),
        },
      }
    );
    if (result.data.success === true) {
      toast.success("Tenant Deleted Successfully!");
    } else {
      toast.error("Error in deleting tenant!");
    }
    return result.data;
  } catch (error) {
    console.log("error in hardDeleteTenant", error);
    toast.error("Error in deleting tenant!");
  }
};

export const loadTransactions = async (
  type,
  searchVal,
  currentPage,
  sort_type = "desc",
  sortBy = "Latest",
  signal = null
) => {
  try {
    var sort_by = sortBy;
    if (sortBy == "Latest" || sortBy == null) {
      sort_by = "created_at";
      sort_type = "desc";
    }
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/transaction/list?type=${type}&page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&searchText=${searchVal}&sortType=${sort_type}&sortBy=${sort_by}`,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
        signal,
      }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("loadTransactions [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log(err);
  }
};

export const createSubAdmin = async (user_data) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/users/signup`,
      user_data,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    let serverResponse = res.data;
    toast.success("Sub Admin Created");
    return serverResponse;
  } catch (err) {
    console.log(err);
    toast.error(err.response.data.error);
  }
};

export const getAdminList = async () => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/admin/getList`, {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    console.log(err);
    toast.error(err.response.data.error);
  }
};
export const changeUserStatus = async (data) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/users/change/status`,
      data,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    console.log(err);
    toast.error(err.response.data.error);
  }
};

export const adminLogin = async (data) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/admin/user/login`, data, {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    console.log(err);
    toast.error(err.response.data.error);
  }
};

export const viewAsLandlord = async (tenantid) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/admin/tenant/view`, { tenantid }, {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    let serverResponse = res.data;
    return serverResponse;
  }
  catch (err) {
    console.log(err);
    toast.error(err.response.data.error);
  }
}

export const skorLoginAdmin = async (tenantId) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/admin/skor/login?tenantId=${tenantId}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    let serverResponse = res.data;
    return serverResponse;
  }
  catch (err) {
    console.log(err);
    toast.error(err.response?.data?.errormsg || "Error logging in as admin");
    throw err;
  }
}

export const updateBulkUserInfo = async (formData = {}, ids = [], type) => {
  try {
    const data = {
      formData,
      ids: ids,
      type,
    };
    const result = await axiosInstance.patch(
      `${BASE_URL}/users/bulk/update/info`,
      data,
      {
        headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
      }
    );
  } catch (error) {
    toast.error("Error while updating info!");
  }
};

export const loadPotentialLandlords = async (
  type,
  currentPage,
  sort_type = "desc",
  sortBy = "Latest"
) => {
  try {
    var sort_by = sortBy;
    if (sortBy == "Latest" || sortBy == null) {
      sort_by = "created_at";
      sort_type = "desc";
    }
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/transaction/potentials/landlords?type=${type}&page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&sortType=${sort_type}&sortBy=${sort_by}`,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    console.log(err);
  }
};
export const updateCompanyData = async (formData, landlordId) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/updateCompany/${landlordId}`,
      formData,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "Content-Type": "multipart/form-data",
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return res;
  } catch (err) {
    toast.error("Error In Uploading File!");
  }
};
export const uploadLandlordFiles = async (formData, landlordId) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/upload/landlord/docs/${landlordId}`,
      formData,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "Content-Type": "multipart/form-data",
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return res;
  } catch (err) {
    toast.error("Error In Uploading File!");
  }
};
export const fetchLandlordFiles = async (landlordId) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/fetch/landlord/docs/${landlordId}`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return res;
  } catch (err) { }
};

export const fetchTranslations = async () => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/admin/getTranslations`, {
      headers: {
        "Accept-Language": localStorage.getItem("i18nextLng"),
        "x-access-token": localStorage.getItem("token"),
      },
    });
    return res;
  } catch (err) { }
};

export const updateTranslations = async (data) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/updateTranslations`,
      data,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return res;
  } catch (err) {
    toast.error("Error In Uploading File!");
  }
};

export const getTenantJoinedFromList = async () => {
  try {
    const docs = await axiosInstance.get(
      `${BASE_URL}/admin/tenants/joined-from-list`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return docs;
  } catch (err) {
    console.log(err);
    toast.error("Error while fetching Tenant KYC Docs!");
  }
};

export const getEmploymentTypes = async (signal = null) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/tenants/employment-types`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
        },
        signal,
      }
    );
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log(err);
    // Fallback to admin route if tenant route fails (in case backend moves it)
    try {
      const fallback = await axiosInstance.get(
        `${BASE_URL}/admin/tenants/employment-types`,
        {
          headers: {
            "Accept-Language": localStorage.getItem("i18nextLng"),
            "x-access-token": localStorage.getItem("token"),
          },
          signal,
        }
      );
      return fallback.data;
    } catch (_e) {
      return { status: "Error", employment_types: [] };
    }
  }
};

export const downloadTinkReport = async (tenant_id) => {
  try {
    const docs = await axiosInstance.get(
      `${BASE_URL}/admin/get/tink/report/${tenant_id}`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
          responseType: "blob",
        },
      }
    );
    return docs;
  } catch (err) {
    console.log(err);
    toast.error("Error while fetching Tenant KYC Docs!");
  }
};

export const addLandlord = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${BASE_URL}/admin/create/landlord`,
      data
    );
    return response;
  } catch (err) {
    console.log(err);
    // toast.error("Error while creating landlord!");
    throw new Error(err);
  }
};

export const editLandlord = async (data) => {
  try {
    const response = await axiosInstance.put(
      `${BASE_URL}/admin/edit/landlord`,
      data
    );
    return response;
  } catch (err) {
    console.log(err);
    // toast.error("Error while creating landlord!");
    throw new Error(err);
  }
};

export const updateLandlordSkipSteps = async (data) => {
  try {
    const response = await axiosInstance.put(
      `${BASE_URL}/admin/landlord/skip-steps`,
      data,
    );
    return response;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const getAllAgencies = async () => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/admin/get/all/agencies`
    );
    return response;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const fetchAgencyDetails = async (agency_id) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/admin/get/agency/details/${agency_id}`
    );
    return response;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const getDocumentAnalysis = async (user_id) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/tenants/download/document/report/${user_id}`
    );
    return res.data;
  } catch (err) {
    console.log(err, "Error in getDocumentAnalysis");
  }
};

export const runOrchestratorAnalysis = async (formData) => {
  try {
    const result = await axiosInstance.post(SKOR_MODAL_PROXY_API, formData, {
      headers: {
        "x-access-token": localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
        "Accept-Language": localStorage.getItem("i18nextLng"),
      },
    });

    return result.data;
  } catch (error) {
    toast.error("Error while running analysis!");
    throw error;
  }
};


export const runForensicAnalysis = async (formData) => {
  try {
    const result = await axiosInstance.post(
      `${BASE_URL}/tenants/forensic-analysis`,
      formData,
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
          "Accept-Language": localStorage.getItem("i18nextLng"),
        },
      }
    );
    return result.data;
  } catch (error) {
    toast.error("Error while sending while!");
  }
};

export const runExperianReport = async (formData) => {
  try {
    const result = await axiosInstance.post(
      `${BASE_URL}/tenants/experian-report`,
      formData
    );
    return result.data;
  } catch (error) {
    toast.error("Error while sending while!");
  }
};

export const runForensic = async (email) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/admin/runForensic?email=${email}`
    );
    return response;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};
export const runTenantAnalysis = async (tenantId) => {
  try {
    const response = await axiosInstance.post(
      `${BASE_URL}/admin/re-run-analysis/${tenantId}`
    );
    return response;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const togglerSelfServingStatus = async (landlordIds) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/togglerSelfServingStatus`,
      { landlordIds: landlordIds },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );

    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    return err;
  }
};

export const togglerInsuranceStatus = async (landlordIds) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/togglerInsuranceServiceStatus`,
      { landlordIds: landlordIds },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );

    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    return err;
  }
};

export const togglerSkorProtectServiceStatus = async (landlordIds) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/togglerSkorProtectServiceStatus`,
      { landlordIds: landlordIds },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );

    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    return err;
  }
};

export const togglerAffidavitStatus = async (landlordIds) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/togglerAffidavitServiceStatus`,
      { landlordIds: landlordIds },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );

    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    return err;
  }
};

export const togglerCapacityReportStatus = async (landlordIds) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/capacity-report-status`,
      { landlordIds: landlordIds },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );

    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    return err;
  }
};

export const getTenantDomains = async (tenant_id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/admin/get-workspace-info-for-tenant/${tenant_id}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    console.log(err);
  }
};

export const getLLMCostStats = async (filters = {}) => {
  try {
    // Filter out empty strings/nulls to avoid sending empty params
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "" && value !== null && value !== "__llm" && value !== "__third_party")
    );
    const params = new URLSearchParams(cleanFilters);
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/llm-costs/stats?${params.toString()}`,
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    return res.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getLLMCostTenantSummaries = async (filters = {}, page = 1, limit = constants.LISTING_ROWLIMIT) => {
  try {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "" && value !== null && value !== "__llm" && value !== "__third_party")
    );
    const params = new URLSearchParams({ ...cleanFilters, page, limit });
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/llm-costs/tenants?${params.toString()}`,
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    return res.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getLLMCostHistory = async (filters = {}, page = 1, limit = constants.LISTING_ROWLIMIT) => {
  try {
    // Filter out empty strings/nulls
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "" && value !== null)
    );
    const params = new URLSearchParams({ ...cleanFilters, page, limit });
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/llm-costs/history?${params.toString()}`,
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    return res.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getVoiceConversations = async (filters = {}, page = 1, limit = 20, signal = null) => {
  try {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "" && value !== null && value !== undefined)
    );
    const params = new URLSearchParams({ ...cleanFilters, page, limit });
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/voice-conversations?${params.toString()}`,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
        signal,
      }
    );
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getVoiceConversations [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getVoiceConversations [ERROR]", err);
    return null;
  }
};

export const getTenantBankStatusMetrics = async ({ start_date = "", end_date = "", signal = null } = {}) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-metrics/bank-status?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getTenantBankStatusMetrics [ERROR]", err);
    return null;
  }
};

export const getTenantClaveMetrics = async ({ start_date = "", end_date = "", signal = null } = {}) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-metrics/clave-done?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getTenantClaveMetrics [ERROR]", err);
    return null;
  }
};

export const getTenantDocumentMetrics = async ({ start_date = "", end_date = "", tenant_id = "", signal = null } = {}) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    if (tenant_id) params.append("tenant_id", tenant_id);

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-metrics/tenant-docs?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getTenantDocumentMetrics [ERROR]", err);
    return null;
  }
};

export const getOnboardingConversionMetrics = async ({
  start_date = "",
  end_date = "",
  nationality = [],
  employment_status = [],
  landlord_id = [],
  signal = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    nationality.forEach((value) => params.append("nationality", value));
    employment_status.forEach((value) => params.append("employment_status", value));
    landlord_id.forEach((value) => params.append("landlord_id", value));

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-metrics/onboarding-conversion?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getOnboardingConversionMetrics [ERROR]", err);
    return null;
  }
};

export const getProfileCompletionTimeMetrics = async ({ start_date = "", end_date = "", tenant_id = "", signal = null } = {}) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    if (tenant_id) params.append("tenant_id", tenant_id);

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-metrics/profile-completion-time?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getProfileCompletionTimeMetrics [ERROR]", err);
    return null;
  }
};

export const getTenantListWithMetrics = async ({
  page = 1,
  limit = 20,
  search = "",
  clave_done = "",
  bank_status = "",
  profile_completed = "",
  nationality = [],
  employment_status = [],
  landlord_id = [],
  signal = null
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);
    if (search) params.append("search", search);
    if (clave_done) params.append("clave_done", clave_done);
    if (bank_status) params.append("bank_status", bank_status);
    if (profile_completed) params.append("profile_completed", profile_completed);
    nationality.forEach((value) => params.append("nationality", value));
    employment_status.forEach((value) => params.append("employment_status", value));
    landlord_id.forEach((value) => params.append("landlord_id", value));

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-list?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    console.log("getTenantListWithMetrics [SUCCESS]", res.data);
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getTenantListWithMetrics [ERROR]", err);
    return null;
  }
};


export const getUserMetrics = async ({
  start_date = "",
  end_date = "",
  nationality = [],
  employment_status = [],
  landlord_id = [],
  signal = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    nationality.forEach((value) => params.append("nationality", value));
    employment_status.forEach((value) => params.append("employment_status", value));
    landlord_id.forEach((value) => params.append("landlord_id", value));

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-metrics/user-metrics?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    console.log("getUserMetrics [SUCCESS]", res.data);
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getUserMetrics [ERROR]", err);
    return null;
  }
};

export const getTenantListFilterOptions = async (signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/tenant-list/filter-options`,
      signal,
    });
    console.log("getTenantListFilterOptions [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getTenantListFilterOptions [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getTenantListFilterOptions [ERROR] =>", err);
    return { success: false, data: {} };
  }
};

export const getInsuranceProtectLandlords = async ({
  page = 1,
  limit = 20,
  searchText = "",
  signal = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (limit) params.append("limit", limit);
    if (searchText) params.append("searchText", searchText);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/insurance-and-skor-protect/landlords?${params.toString()}`,
      signal,
    });

    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {

      return { status: "canceled" };
    }

    return { success: false, data: {} };
  }
};

export const getInsuranceProtectLandlordDetails = async ({
  landlordId,
  workspaceId = "",
  product = "",
  status = "",
  page = 1,
  limit = 20,
  signal = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (workspaceId) params.append("workspaceId", workspaceId);
    if (product && product !== "all") params.append("product", product);
    if (status && status !== "all") params.append("status", status);
    if (page) params.append("page", page);
    if (limit) params.append("limit", limit);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/insurance-and-skor-protect/list/${landlordId}?${params.toString()}`,
      signal,
    });

    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {

      return { status: "canceled" };
    }

    return { success: false, data: {} };
  }
};

export const resolveInsuranceCoverageReview = async ({
  propertyId,
  policyStartDate,
  policyEndDate,
  policyDocument,
}) => {
  const formData = new FormData();
  formData.append("policy_start_date", policyStartDate);
  formData.append("policy_end_date", policyEndDate);
  formData.append("policy_document", policyDocument);

  const axiosRes = await axiosInstance({
    method: "PATCH",
    headers: { "x-access-token": localStorage.getItem("token") },
    data: formData,
    url: `${BASE_URL}/admin/insurance-and-skor-protect/policy/${propertyId}`,
  });

  return axiosRes.data;
};

export const translate = async ({translation,signal}={signal:null}) =>{
  try {
    const axiosRes = await axiosInstance({
      method: "POST",
      headers: { "x-access-token": localStorage.getItem("token") },
      data: translation,
      url: `${BASE_URL}/admin/translate`,
      signal
    });
    console.log("translate [SUCCESS]", axiosRes.data);
    return axiosRes.data
  } catch (error) {
    if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
      console.log("translate [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("translate [ERROR] =>", error);
    return { success: false, data: {} };
  }
}

export const getThirdPartyUsage = async (filters = {}, page = 1, limit = constants.LISTING_ROWLIMIT, signal = null) => {
  try {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "" && value !== null)
    );
    const params = new URLSearchParams({ ...cleanFilters, page, limit });
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/third-party-usage?${params.toString()}`,
      signal,
    });
    console.log("getThirdPartyUsage [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getThirdPartyUsage [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getThirdPartyUsage [ERROR] =>", err);
    return null;
  }
};

export const getThirdPartyUsageStats = async (filters = {}, signal = null) => {
  try {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "" && value !== null)
    );
    const params = new URLSearchParams(cleanFilters);
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/third-party-usage/stats?${params.toString()}`,
      signal,
    });
    console.log("getThirdPartyUsageStats [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getThirdPartyUsage [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getThirdPartyUsageStats [ERROR] =>", err);
    return null;
  }
};

export const getPillarWeights = async (signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/config/policy-weights`,
      signal,
    });
    console.log("getPillarWeights [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getPillarWeights [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getPillarWeights [ERROR] =>", err);
    return null;
  }
};

export const updatePillarWeights = async (pillarWeights, signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "PATCH",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/config/policy-weights`,
      data: { pillarWeights },
      signal,
    });
    console.log("updatePillarWeights [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("updatePillarWeights [ERROR] =>", err);
    throw err;
  }
};

export const getScoringSubscores = async (signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/config/scoring-subscores`,
      signal,
    });
    console.log("getScoringSubscores [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getScoringSubscores [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getScoringSubscores [ERROR] =>", err);
    return null;
  }
};

export const updateScoringSubscores = async (subScores, signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "PATCH",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/config/scoring-subscores`,
      data: { subScores },
      signal,
    });
    console.log("updateScoringSubscores [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("updateScoringSubscores [ERROR] =>", err);
    throw err;
  }
};

export const getScoringPillars = async (signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/config/scoring-pillars`,
      signal,
    });
    console.log("getScoringPillars [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getScoringPillars [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getScoringPillars [ERROR] =>", err);
    return null;
  }
};

export const updateScoringPillars = async (pillars, signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "PATCH",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/config/scoring-pillars`,
      data: { pillars },
      signal,
    });
    console.log("updateScoringPillars [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("updateScoringPillars [ERROR] =>", err);
    throw err;
  }
};

export const getPolicyThreshold = async (signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/config/policy-threshold`,
      signal,
    });
    console.log("getPolicyThreshold [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getPolicyThreshold [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getPolicyThreshold [ERROR] =>", err);
    return null;
  }
};

export const updatePolicyThreshold = async (threshold, signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "PATCH",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/config/policy-threshold`,
      data: { threshold },
      signal,
    });
    console.log("updatePolicyThreshold [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("updatePolicyThreshold [ERROR] =>", err);
    throw err;
  }
};

export const getPolicyAggregationStrategy = async (signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/config/policy-aggregation-strategy`,
      signal,
    });
    console.log("getPolicyAggregationStrategy [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getPolicyAggregationStrategy [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getPolicyAggregationStrategy [ERROR] =>", err);
    return null;
  }
};

export const updatePolicyAggregationStrategy = async (aggregationStrategy, signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "PATCH",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/config/policy-aggregation-strategy`,
      data: { aggregationStrategy },
      signal,
    });
    console.log("updatePolicyAggregationStrategy [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("updatePolicyAggregationStrategy [ERROR] =>", err);
    throw err;
  }
};

export const getLandlordWorkspaces = async (landlord_id, signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/workspaces/list/${landlord_id}`,
      signal,
    });
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getLandlordWorkspaces [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getLandlordWorkspaces [ERROR] =>", err);
    throw err;
  }
};

export const addWorkspaceCredit = async (workspace_id, amount, signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "POST",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/workspaces/add-credit`,
      data: { workspace_id, amount },
      signal,
    });
    return axiosRes.data;
  } catch (err) {
    console.log("addWorkspaceCredit [ERROR] =>", err);
    throw err;
  }
};

export const getLandlordInsurancePricing = async (
  landlordId,
  signal = null
) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/landlords/${landlordId}/insurance-pricing`,
      signal,
    });
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getLandlordInsurancePricing [ERROR] =>", err);
    throw err;
  }
};

export const updateLandlordInsurancePricing = async (
  landlordId,
  pricing,
  signal = null
) => {
  try {
    const axiosRes = await axiosInstance({
      method: "PUT",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/landlords/${landlordId}/insurance-pricing`,
      data: pricing,
      signal,
    });
    return axiosRes.data;
  } catch (err) {
    console.log("updateLandlordInsurancePricing [ERROR] =>", err);
    throw err;
  }
};

export const createApiToken = async (data, signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "POST",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/api-keys`,
      data,
      signal,
    });
    console.log("createApiToken [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("createApiToken [ERROR] =>", err);
    throw err;
  }
};

export const updateApiToken = async (id, data, signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "PATCH",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/api-keys/${id}`,
      data,
      signal,
    });
    console.log("updateApiToken [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("updateApiToken [ERROR] =>", err);
    throw err;
  }
};

export const getApiTokens = async (signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/api-keys`,
      signal,
    });
    console.log("getApiTokens [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getApiTokens [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getApiTokens [ERROR] =>", err);
    throw err;
  }
};

// ---------------------------------------------------------------------------
// Support tickets (ops panel). See docs/ticketing-module.md.
// ---------------------------------------------------------------------------
export const getTickets = async (filters = {}, page = 1, limit = 20, signal = null) => {
  try {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(
        ([_, value]) => value !== "" && value !== null && value !== undefined
      )
    );
    const params = new URLSearchParams({ ...cleanFilters, page, limit });
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/tickets?${params.toString()}`,
      { headers: { "x-access-token": localStorage.getItem("token") }, signal }
    );
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getTickets [ERROR]", err);
    return null;
  }
};

export const getTicketById = async (id, signal = null) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/admin/tickets/${id}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    return res.data;
  } catch (err) {
    console.log("getTicketById [ERROR]", err);
    return null;
  }
};

export const updateTicket = async (id, data, signal = null) => {
  try {
    const res = await axiosInstance({
      method: "PATCH",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/tickets/${id}`,
      data,
      signal,
    });
    return res.data;
  } catch (err) {
    console.log("updateTicket [ERROR]", err);
    throw err;
  }
};

export const addTicketMessage = async (id, data, signal = null) => {
  try {
    const res = await axiosInstance({
      method: "POST",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/tickets/${id}/messages`,
      data,
      signal,
    });
    return res.data;
  } catch (err) {
    console.log("addTicketMessage [ERROR]", err);
    throw err;
  }
};

export const getTicketAssignees = async (signal = null) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/admin/tickets-assignees`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    return res.data;
  } catch (err) {
    console.log("getTicketAssignees [ERROR]", err);
    return null;
  }
};

export const linkTicketAccount = async (id, data, signal = null) => {
  try {
    const res = await axiosInstance({
      method: "POST",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/tickets/${id}/link`,
      data,
      signal,
    });
    return res.data;
  } catch (err) {
    console.log("linkTicketAccount [ERROR]", err);
    throw err;
  }
};
